import { createSelector } from 'reselect'

const _currentActivity = state => {
  const activityIndex = state.quest.activities.findIndex(function (activity) {
    return activity.id === state.quest.activityId
  })
  return state.quest.activities[activityIndex]
}

export const currentActivity = createSelector([_currentActivity], activity => {
  return activity
})



// WEBPACK FOOTER //
// ./src/selectors/activity.js